import { Routes, Route, NavLink } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Releases from "./pages/Releases";
import FeatureRequests from "./pages/FeatureRequests";
import BugReports from "./pages/BugReports";
import Versions from "./pages/Versions";

const roleBadgeColors: Record<string, string> = {
  admin: "#ef4444",
  authorizer: "#f59e0b",
  user: "#3b82f6",
};

function AuthenticatedApp() {
  const { session, logout, role } = useAuth();

  if (!session) return <Login />;

  return (
    <div className="app">
      <nav className="sidebar">
        <div className="sidebar-header">
          <h1>POS DevPortal</h1>
          <span style={{ fontSize: "0.75rem", opacity: 0.7 }}>POS System Management</span>
        </div>
        <ul className="nav-links">
          <li>
            <NavLink to="/">Dashboard</NavLink>
          </li>
          <li>
            <NavLink to="/releases">Releases</NavLink>
          </li>
          <li>
            <NavLink to="/versions">Versions</NavLink>
          </li>
          <li>
            <NavLink to="/features">Feature Requests</NavLink>
          </li>
          <li>
            <NavLink to="/bugs">Bug Reports</NavLink>
          </li>
        </ul>

        {/* User info at bottom */}
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-name">{session.username}</div>
            <div className="user-role">
              <span
                className="role-pill"
                style={{ backgroundColor: roleBadgeColors[role || "user"] }}
              >
                {role}
              </span>
            </div>
          </div>
          <button className="logout-btn" onClick={logout} title="Sign out">
            ↪ Sign Out
          </button>
        </div>
      </nav>
      <main className="content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/releases" element={<Releases />} />
          <Route path="/versions" element={<Versions />} />
          <Route path="/features" element={<FeatureRequests />} />
          <Route path="/bugs" element={<BugReports />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
    </AuthProvider>
  );
}

export default App;
